import Bookings from "./Bookings";
import './bookings.scss';

export default Bookings;